import React, { useEffect, useState } from "react";
import { Card, Col, Row, Space, DatePicker, message, Spin } from "antd";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceLine,
  PieChart,
  Pie,
} from "recharts";

import dayjs from "dayjs";
import { getDataDashboard } from "../api/Chart";

const Dashboard = () => {
  const [sessiData, setSessiData] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(dayjs());
  const COLORS_PIE = ["#00C49F", "#FF8042", "#FFBB28", "#0088FE", "#FF4444"];
  const [dataDashboard, setDataDashboard] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const userData = sessionStorage.getItem("user");
    if (userData) {
      setSessiData(JSON.parse(userData));
    }
  }, []);

  useEffect(() => {
    if (sessiData && selectedMonth) {
      fetchData();
    }
  }, [sessiData, selectedMonth]);

  const fetchData = async () => {
    if (!sessiData?.[0]?.user?.[0]?.employeeId) return;
    setLoading(true);
    try {
      const result = await getDataDashboard(
        sessiData[0].user[0].employeeId,
        selectedMonth.format("YYYY-MM")
      );

      if (result.status && result.data?.length > 0) {
        setDataDashboard(result.data[0]);
      } else {
        message.error("Data kosong atau format tidak sesuai.");
      }
    } catch (error) {
      console.error(error);
      message.error("Gagal memuat data.");
    } finally {
      setLoading(false);
    }
  };

  if (
    !dataDashboard ||
    !dataDashboard.kehadiran ||
    !dataDashboard.top3kehadiran ||
    loading
  ) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <Space style={{ marginBottom: 24 }}>
        <DatePicker
          picker="month"
          value={dayjs(selectedMonth)}
          onChange={(date) => {
            if (date) setSelectedMonth(date);
          }}
        />
      </Space>

      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={8}>
          <Card title="Total Karyawan">{dataDashboard.total_karyawan}</Card>
        </Col>
        <Col span={8}>
          <Card title="Total Kehadiran">
            {dataDashboard.kehadiran[0].value.toFixed(1)}% Hadir
          </Card>
        </Col>
        <Col span={8}>
          <Card title="Total Gaji">
            Rp {dataDashboard.total_gaji.toLocaleString()}
          </Card>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={24}>
          <Card title="Statistik Kehadiran" style={{ textAlign: "center" }}>
            <div style={{ display: "inline-block" }}>
              <PieChart width={400} height={400}>
                <Pie
                  data={dataDashboard.kehadiran}
                  cx="50%"
                  cy="50%"
                  outerRadius={100}
                  fill="#8884d8"
                  dataKey="value"
                  label={(props) => {
                    const { payload, percent } = props;
                    return `${payload.name}: ${(percent * 100).toFixed(1)}%`;
                  }}
                >
                  {dataDashboard.kehadiran.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS_PIE[index % COLORS_PIE.length]}
                    />
                  ))}
                </Pie>

                <Tooltip formatter={(value) => `${value}%`} />
                <Legend />
              </PieChart>
            </div>
          </Card>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={24}>
          <Card title="Top 3 Kehadiran & Alfa Terbanyak">
            <BarChart
              width={900}
              height={400}
              data={dataDashboard.top3kehadiran}
              margin={{
                top: 5,
                right: 10,
                left: 10,
                bottom: 50,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" interval={0} />
              <YAxis />
              <Tooltip />
              <Legend />
              <ReferenceLine y={0} stroke="#000" />
              <Bar dataKey="hadir" fill="#8884d8" />
              <Bar dataKey="alfa" fill="red" />
            </BarChart>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
